import React from 'react'
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css'
import { connect } from 'react-redux'
import { get, debounce } from 'lodash'
import { fetchAgents, deleteAgent } from '../../actions/remote_api'
import AgentTable from './AgentTable'

class AgentTableContainer extends React.Component {
  abortController = null

  componentDidMount() {
    this.handleDataChange = debounce(this.handleDataChange, 1000)
  }

  componentWillUnmount() {
    this.abortInFlights()
  }

  abortInFlights() {
    if (this.abortController) {
      this.abortController.abort()
      this.abortController = undefined
    }
  }

  handleDataChange = (filter) => {
    this.abortInFlights()
    this.abortController = new AbortController()

    this.props.fetchAgents(
      {
        page: filter.currentPage,
        limit: filter.sizePerPage,
        sort: filter.sort,
        order: filter.order,
        ...this.createQueryFilter(filter.query),
      },
      {
        signal: this.abortController.signal,
      },
    )
  }

  createQueryFilter = (filter) => {
    if (!filter) return undefined

    const queryfilter = {}
    if (filter.code) queryfilter.code_like = filter.code
    if (filter.name) queryfilter.name_like = filter.name
    if (filter.phone1) queryfilter.phone1_like = filter.phone1
    if (filter.phone2) queryfilter.phone2_like = filter.phone2
    if (filter.email) queryfilter.email_like = filter.email
    if (filter.type) queryfilter.type = filter.type
    return queryfilter
  }

  render() {
    return (
      <AgentTable
        {...this.props}
        customDefaultSizePerPage={10}
        onDataChange={this.handleDataChange}
      />
    )
  }
}

export default connect(
  ({ fetch }) => ({
    isLoading: get(fetch, 'agent.isLoading.list', false),
    instances: get(fetch, 'agent.list', []),
    totalCount: get(fetch, 'agent.totalCount'),
  }),
  { fetchAgents, deleteInstance: deleteAgent },
)(AgentTableContainer)
